<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="page_ii"></a>Works by the Marquis de Sade Published by Grove Press</p>
<p class="center"><em>Justine, Philosophy in the Bedroom, and Other Writings</em></p>
<p class="center"><em>The 120 Days of Sodom and Other Writings</em></p>
<p class="center"><em>Juliette</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?357a18ce